import PropTypes from "prop-types";
import React from "react";
import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu } from "../../icons/Menu";
import { Menu1 } from "../../icons/Menu1";
import { Recruit } from "../Recruit22";
import { MenuItem } from "../MenuItem";
import "./style.css";

export const Nav = ({ nav, className }) => {
  const[navx, setNavx] = useState(nav)

  function handleClick() {
    setNavx((navx === "mobile-expanded")? "mobile":"mobile-expanded");
  }

  return (
    <div className={`nav nav-${navx} ${className}`}>
      <div className="NAV-2">
        <div className="logo-wrapper">
          <div className="logo">
            <a href="/">
              <Recruit className="recruit" recruitClassName="recruit-instance"/>
            </a>
          </div>
        </div>
        {navx === "mobile-expanded"? <a onClick={handleClick}><Menu1 className="instance-node" /></a> : <a onClick={handleClick}><Menu onClick={handleClick} className="instance-node" /></a>}
          <div className="MENU-2">
            <MenuItem className="menu-item-instance" text="Talent Solutions" navto="/talent" />
            <MenuItem className="menu-item-instance" text="Job Opportunities" navto="/jobs" />
            <MenuItem className="menu-item-instance" text="Client Testimonials" navto="/testimonials" />
            <MenuItem className="menu-item-instance" text="About Us" navto="/about-us" />
          </div>
      </div>
      {navx === "mobile-expanded" && (
        <div className="MENU-3">
          <MenuItem className="menu-item-instance" divClassName="menu-item-2" text="Talent Solutions" navto="/talent" />
          <MenuItem className="menu-item-instance" divClassName="menu-item-2" text="Job Opportunities" navto="/jobs" />
          <MenuItem className="menu-item-instance" divClassName="menu-item-2" text="Client Testimonials" navto="/testimonials" />
          <MenuItem className="menu-item-instance" divClassName="menu-item-2" text="About Us" navto="/about-us" />
        </div>
      )}
    </div>
  );
};

Nav.propTypes = {
  nav: PropTypes.oneOf(["mobile-expanded", "mobile", "default"]),
};
